import React, { Component } from 'react'
import PropTypes from 'prop-types'
import "react-responsive-modal/styles.css";
import { reduxForm } from 'redux-form';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SostaOnlineApiService from 'services/SostaOnlineApiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import  * as solidIcons  from '@fortawesome/free-solid-svg-icons'
import moment from 'moment';
import RequestConfirmModal from 'components/General/RequestConfirmModal';

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reportActions } from 'redux/modules/Report' 
import {actions as authActions} from 'redux/modules/Auth'
import { ADMIN } from 'libs/roles'


moment.locale('it')

/**
 * --------------------------------------------------------------------------
 * @param {*} state 
 * @returns 
 */
const mapStateToProps = (state) => {
  return {
    backofficeValues: state.form.backofficeSettings,
    auth: state.auth,
    stateReport : state.report   
  }
}

/**
 * --------------------------------------------------------------------------
 * @param {*} dispatch 
 * @returns 
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    authActions:   bindActionCreators(authActions,   dispatch),
    reportActions: bindActionCreators(reportActions, dispatch)
  }
}


class BackofficeEditVehicleOwnershipType extends Component {

  static propTypes = {    
    vehicleOwnershipTypeId:  PropTypes.number,    
    onSave:                PropTypes.func.isRequired,
    onDelete:              PropTypes.func.isRequired,
    onCancelEdit:          PropTypes.func.isRequired,
  }

  /**
   * --------------------------------------------------------------
   * @param {*} props 
   */
  constructor(props) {
    super(props)

    this.state = {      
      vehicleOwnershipType: this.getNullVehicleOwnershipType(),
      checkErrors: null,
      sendErrors: null,
      displayColorPicker: false,
      showConfirmDelete: false,      
         
    }

    this.save                        = this.save.bind(this)
    this.checkFields                 = this.checkFields.bind(this)        
    this.getNullVehicleOwnershipType = this.getNullVehicleOwnershipType.bind(this)
    this.delete                      = this.delete.bind(this)
       
  }

  /**
   * --------------------------------------------------------------
   * @returns 
   */
  getNullVehicleOwnershipType() {
    var nullVehicleOwnershipType = { id: null, name: '' }

    return nullVehicleOwnershipType    
  }

  /**
   * --------------------------------------------------------------
   * 
   */
  stateInit() {
    this.setState({      
      vehicleOwnershipType: this.getNullVehicleOwnershipType(),
      checkErrors: null,
      sendErrors: null,      
      displayColorPicker: false,
      showConfirmDelete: false
    })    

  }

  /**
   * --------------------------------------------------------------
   */
  componentDidMount() {
    this.stateInit()
    this.fetchData()
  }

  /**
   * --------------------------------------------------------------
   * @param {*} prevProps 
   */
   componentDidUpdate(prevProps) {       

    if ( prevProps.vehicleOwnershipTypeId != this.props.vehicleOwnershipTypeId  ) {
      this.stateInit()
      this.fetchData()
    }
        
  }

  /**
   * --------------------------------------------------------------
   * 
   */
  async fetchData() {
    
    if ( this.props.vehicleOwnershipTypeId != null ) {
      var vehicleOwnershipType = await SostaOnlineApiService.fetchVehicleOwnershipType(this.props.vehicleOwnershipTypeId)
      .catch( error => {
        console.log("ERROR",error)
        this.setState({ sendErrors: "Errore nella richiesta datti" })
        this.setState({vehicleOwnershipType: this.getNullVehicleOwnershipType()})
      })

      if ( vehicleOwnershipType != null && vehicleOwnershipType.data != null  ) {        
        this.setState({vehicleOwnershipType: vehicleOwnershipType.data })
      }
      else {
        this.setState({vehicleOwnershipType: this.getNullVehicleOwnershipType()})
      }
    }
    else {
      this.setState({vehicleOwnershipType: this.getNullVehicleOwnershipType()})
    }

  }

  /**
   * --------------------------------------------------------------
   * @returns 
   */
  checkFields() {

    var errors = []   

    if ( this.state.vehicleOwnershipType.name == null || this.state.vehicleOwnershipType.name.trim().length <= 0 ) {
      errors.push("Nome non specificato")
    }
    
    return errors;

  }

  /**
   * --------------------------------------------------------------
   * @returns 
   */
  save() {
    
    var errors = this.checkFields()
    this.setState({checkErrors: errors})

    if ( errors != null && errors.length > 0 ) {      
      return
    }    

    if ( this.state.vehicleOwnershipType.id == null  ) {

      SostaOnlineApiService.createVehicleOwnershipType(this.state.vehicleOwnershipType)
      .then( result => {    
        
        var vehicleOwnershipTypeId  = null

        if ( result.data != null && result.data.id != null )
          vehicleOwnershipTypeId =  result.data.id
        
        if ( this.props.onSave != null ) {
          this.props.onSave(vehicleOwnershipTypeId)
        }           
  
      })
      .catch( error => {
        console.log("ERROR",error)
        this.setState({ sendErrors: "Errore durante Il salvataggio, riprovare più tardi!" })
      })

    }
    else {
      SostaOnlineApiService.updateVehicleOwnershipType(this.state.vehicleOwnershipType)
      .then( result => {      
        
        if ( this.props.onSave != null ) {
          this.props.onSave(this.props.vehicleOwnershipTypeId)
        }        
  
      })
      .catch( error => {
        console.log("ERROR",error)
        this.setState({ sendErrors: "Errore durante Il salvataggio, riprovare più tardi!" })
      })

    }

  }

  /**
   * --------------------------------------------------------------
   * 
   */
  async delete() {    

    if ( this.props.vehicleOwnershipTypeId != null  ) {

      await SostaOnlineApiService.deleteVehicleOwnershipType(this.props.vehicleOwnershipTypeId)
        .then( result => {      
          
          if ( this.props.onDelete != null ) {
            this.props.onDelete()
          }                    

        })
        .catch( error => {
          console.log("ERROR",error)

          if ( error.error != null ) {
            this.setState({ sendErrors: error.error })
          }
          else {
            this.setState({ sendErrors: "Errore durante Il salvataggio, riprovare più tardi!" })
          }
          
        })

      this.setState({ showConfirmDelete: false})

    }

  }


  /**
   * --------------------------------------------------------------
   * 
   */
  onCancelEdit() {
    this.stateInit()
    this.fetchData()

    if ( this.props.onCancelEdit != null )
      this.props.onCancelEdit()
  }

  /**
   * --------------------------------------------------------------
   * @param {*} name 
   */
  setName(name) {
    var vehicleOwnershipType = this.state.vehicleOwnershipType
    vehicleOwnershipType.name=name
    this.setState({vehicleOwnershipType: vehicleOwnershipType})
  }


  /**
   * --------------------------------------------------------------
   * @returns 
   */
  render () {

    const {        
      vehicleOwnershipTypeId 
    } = this.props

    const {
      sendErrors,
      checkErrors,
      vehicleOwnershipType,
      showConfirmDelete
    } = this.state

    if ( this.props.auth.user.role != ADMIN ) {
      return (<div className="text-primary">Utente non autorizzato</div>)
    }

    return (
      <React.Fragment>
              
        { vehicleOwnershipType  == null &&
        <div className="col-md-12">
          <div className="row">          
            <div className="text-center" style={{ margin: "1em" }}>
              <div className="row"><h2>Caricamento in corso...</h2></div>
              <div className="row" style={{padding: "2em", height: "40em"}}>
                <Oval secondaryColor="#02afff"  color="#174c88" height={40} width="100%" />
              </div>
            </div>
          </div>          
        </div>
        }

        { vehicleOwnershipType != null &&
        <div className="col-md-12">
          <div className="app-modal-body">                                  
            
            <React.Fragment>

              { vehicleOwnershipType.id != null &&
              <div className="row" style={{ marginBottom: "1em" }}>
                  <div className="col-xs-3">
                    <h5 style={{ marginTop: 5 , marginBottom: 5, verticalAlign: "top" }}><strong>Id:</strong></h5>
                  </div>
                  
                  <div className="col-xs-9">
                    <h5 style={{ marginTop: 5 , marginBottom: 5, marginLeft: 15, verticalAlign: "top" }}><strong>{vehicleOwnershipType.id}</strong></h5>
                  </div>                                
              </div>
              }
              
              <div className="row" style={{ marginBottom: "1em" }}>
                <div className="col-xs-3">
                  <h5 style={{ marginTop: 10 , marginBottom: 5, verticalAlign: "top" }}><strong>Nome:</strong></h5>
                </div>
                
                <div className="col-xs-9">
                  <input
                    name="name" 
                    className="form-control" 
                    type="text" 
                    onChange={ e => {  this.setName(e.target.value) }}
                    value={vehicleOwnershipType.name}
                    required />
                </div>                                
              </div>              

              <div className="row" style={{ marginBottom: "1em" }}>
                { sendErrors && 
                  <h4 className="col-xs-12 text-danger text-center" style={{marginBottom: '15px', marginTop: '10px'}}>
                    {sendErrors}
                  </h4>
                }
                { checkErrors && checkErrors.length > 0 && 
                  <h4 className="col-xs-12 text-danger text-center" style={{marginBottom: '15px', marginTop: '10px'}}>
                    {checkErrors.map( ( error, index  ) => { return (<div key={index}>{error}</div>) }  )}
                  </h4>
                }
              </div>              
              
              <div className="row" style={{ marginBottom: "1em" }}>
                <div className="col-xs-12 text-center" style={{marginBottom: '15px', marginTop: '10px'}}>
                  <Button className="btn alertBtn" onClick={() => { this.onCancelEdit() } }>Annulla</Button>{' '}
                  <Button className="btn mainBtn"  onClick={() => { this.save() }} >Salva</Button>
                  { vehicleOwnershipTypeId &&
                  <Button className="btn alertBtn" onClick={() => { this.setState({ showConfirmDelete: true })} }><FontAwesomeIcon  size="1x" icon={solidIcons.faTrash} />&nbsp;&nbsp;Elimina</Button>
                  }
                </div>
              </div>          

            </React.Fragment>            
          </div>
        </div>           
        }  

        <RequestConfirmModal
          requestStyle={2}
          requestTitle="Conferma Eliminazione Tipo di Alimentazione"
          requestSubTitle="ATTENZIONE"
          requestMsg={"Proseguendo con l'operazione si eliminerà il tipo di alimentazione "+ vehicleOwnershipType.name +".<br/><br/>L'operazione è irreversibile, si vuole procedere?"}
          show={showConfirmDelete}
          onConfirm={this.delete}
          onRefuse={ () => {this.setState({ showConfirmDelete: false }) }}
        />

       
      </React.Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'BackofficeEditVehicleOwnershipType'})(BackofficeEditVehicleOwnershipType))
